import React from 'react';

const LandingFooter = (props) => {
  return (
    <>
      <div className="landing-footer">
        <h2>Get Started Today!</h2>
        <div className="cards-wrapper">
          <div className="card-home" onClick={() => props.history.push('/sign-up')}>
            <img src="/images/37481-inverted.webp" title="Find your perfect personal chef today!" />
            <h3>Find your perfect personal chef today!</h3>
          </div>

          <div className="card-home" onClick={() => props.history.push('/sign-up-chef')}>
            <img src="/images/483841.png" title="Create a Chef profile to launch your business." />
            <h3>Create a Chef profile to launch your business.</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingFooter;
